const advertisement1 = {
  id: 1,
  passage: `Subject: Introducing the All-New UltraVision X1!

Experience <mark>cutting-edge</mark> technology with the UltraVision X1, the latest 4K Smart TV designed to elevate your <mark>viewing</mark> experience.

Crystal-clear 4K <mark>resolution</mark> for <mark>stunning</mark> picture quality
Built-in AI assistant for hands-free control
Ultra-slim design that fits perfectly in any space

For a limited time, customers who purchase the UltraVision X1 will receive a free soundbar (a $199 value). This <mark>exclusive</mark> offer is available until April 30.

Don't miss out on this opportunity to upgrade your home entertainment system! Visit your nearest <mark>retailer</mark> or order online at www.ultravision.com today!`,

  translation: `제목: 완전히 새로워진 UltraVision X1 출시!

최신 4K 스마트 TV UltraVision X1과 함께 최첨단 기술을 경험하세요. 여러분의 시청 경험을 한 단계 높여드립니다.

놀라운 화질을 위한 선명한 4K 해상도
핸즈프리 제어를 위한 내장 AI 어시스턴트
어떤 공간에도 완벽하게 어울리는 울트라 슬림 디자인

한정된 기간 동안 UltraVision X1 구매 고객에게 사운드바를 무료로 드립니다(199달러 상당). 이 특별 혜택은 4월 30일까지 제공됩니다.

홈 엔터테인먼트 시스템을 업그레이드할 수 있는 이 기회를 놓치지 마세요! Visit your nearest retailer or order online at www.ultravision.com today!`,

  koreanNouns: `Subject: Introducing the All-New UltraVision X1!

Experience <mark>최첨단</mark> technology with the UltraVision X1, the latest 4K Smart TV designed to elevate your <mark>시청</mark> experience.

Crystal-clear 4K <mark>해상도</mark> for <mark>놀라운</mark> picture quality
Built-in AI assistant for hands-free control
Ultra-slim design that fits perfectly in any space

For a limited time, customers who purchase the UltraVision X1 will receive a free soundbar (a $199 value). This <mark>특별한</mark> offer is available until April 30.

Don't miss out on this opportunity to upgrade your home entertainment system! Visit your nearest <mark>판매점</mark> or order online at www.ultravision.com today!`,

  wordPairs: {
    최첨단: "cutting-edge",
    시청: "viewing",
    해상도: "resolution",
    놀라운: "stunning",
    특별한: "exclusive",
    판매점: "retailer",
  },

  questions: [],
};

const advertisement2 = {
  id: 2,
  passage: `Subject: Limited-Time Offer – Up to 50% Off!
The Big Spring Sale Is Here! 

For a limited time only, enjoy up to 50% off on <mark>selected</mark> items across our online store! Whether you're shopping for fashion, electronics, or <mark>home essentials</mark>, this is your chance to save big.

Promotion Details:
- Discount: Up to 50% off on <mark>selected</mark> products
- Offer Valid Until: March 31, 2025

Additional <mark>Perks</mark>:
- Free shipping on orders over $50
- Exclusive members-only coupons (Use code: SPRING10 for an extra 10% off)
- Buy 2, Get 1 Free on select categories

Shop Now: Visit www.springdeals.com to grab these incredible discounts before they're gone!

Hurry! This offer is valid only until March 31, 2025. Don't miss out!

Best regards,
Spring Deals Team`,

  translation: `제목: 한정 시간 특가 - 최대 50% 할인!
대규모 봄맞이 세일이 시작됐습니다! 

한정된 기간 동안 온라인 스토어의 선별된 상품을 최대 50% 할인된 가격으로 만나보세요! 패션, 전자제품, 생활용품 등 쇼핑하시는 모든 품목에서 큰 폭의 할인 혜택을 누리실 수 있습니다.

프로모션 상세 정보:
할인: 선별된 상품 최대 50% 할인
행사 기간: 2025년 3월 31일까지
추가 혜택:

50달러 이상 구매 시 무료 배송
회원 전용 쿠폰 (코드: SPRING10 사용 시 추가 10% 할인)
지정 카테고리 2+1 행사
지금 쇼핑하기: www.springdeals.com에서 놀라운 할인 혜택을 놓치지 마세요!

서두르세요! 이 혜택은 2025년 3월 31일까지만 유효합니다. 기회를 놓치지 마세요!

감사합니다.
Spring Deals 팀`,
  koreanNouns: `Subject: Limited-Time Offer – Up to 50% Off!
The Big Spring Sale Is Here! 

For a limited time only, enjoy up to 50% off on <mark>선별된</mark> items across our online store! Whether you're shopping for fashion, electronics, or <mark>생활용품</mark>, this is your chance to save big.

Promotion Details:
Discount: Up to 50% off on <mark>선별된</mark> products
Offer Valid Until: March 31, 2025
Additional <mark>혜택</mark>:

Free shipping on orders over $50
Exclusive members-only coupons (Use code: SPRING10 for an extra 10% off)
Buy 2, Get 1 Free on select categories
Shop Now: Visit www.springdeals.com to grab these incredible discounts before they're gone!

Hurry! This offer is valid only until March 31, 2025. Don't miss out!

Best regards,
Spring Deals Team`,

  wordPairs: {
    선별된: "selected",
    생활용품: "home essentials",
    혜택: "perks",
  },

  questions: [],
};

const advertisement3 = {
  id: 3,
  passage: `Subject: Experience Luxury at OceanView Resort

Looking for the perfect getaway? OceanView Resort offers a premium vacation experience with <mark>breathtaking</mark> ocean views and world-class <mark>amenities</mark>.

 <mark>Spacious</mark> <mark>suites</mark> with private balconies
 Fine dining restaurants and spa <mark>facilities</mark>
 <mark>Complimentary</mark> airport shuttle and <mark>concierge service</mark>

For a limited time, book a three-night stay and receive a free dinner for two at our signature restaurant.

Don't miss out on this exclusive opportunity to relax in paradise. Visit www.oceanviewresort.com or call (555) 789-4321 to make your reservation today!`,

  translation: `제목: 오션뷰 리조트에서 럭셔리를 경험하세요

완벽한 휴가를 찾고 계신가요? 오션뷰 리조트는 숨막히는 바다 전망과 세계적 수준의 편의시설로 프리미엄 휴가 경험을 제공합니다.

프라이빗 발코니가 있는 넓은 스위트룸
고급 레스토랑과 스파 시설
무료 공항 셔틀과 컨시어지 서비스

한정된 기간 동안, 3박 예약 시 시그니처 레스토랑에서 2인 무료 디너를 제공해 드립니다.

낙원에서 휴식을 취할 수 있는 이 특별한 기회를 놓치지 마세요. Visit www.oceanviewresort.com or call (555) 789-4321 to make your reservation today!`,

  koreanNouns: `Subject: Experience Luxury at OceanView Resort

Looking for the perfect getaway? OceanView Resort offers a premium vacation experience with <mark>숨막히는</mark> ocean views and world-class <mark>편의시설</mark>.

Spacious <mark>스위트룸</mark> with private balconies
Fine dining restaurants and spa <mark>시설</mark>
<mark>무료</mark> airport shuttle and <mark>컨시어지 서비스</mark>

For a limited time, book a three-night stay and receive a free dinner for two at our signature restaurant.

Don't miss out on this exclusive opportunity to relax in paradise. Visit www.oceanviewresort.com or call (555) 789-4321 to make your reservation today!`,

  wordPairs: {
    숨막히는: "breathtaking",
    편의시설: "amenities",
    스위트룸: "suites",
    시설: "facilities",
    무료: "complimentary",
    "컨시어지 서비스": "concierge service",
  },

  questions: [],
};

const advertisement4 = {
  id: 4,
  passage: `Subject: Exclusive Offer – Limited-Time Spring Promotion!

Dear Valued Customer,

We are pleased to announce our Spring Savings Event, offering exclusive discounts of up to 50% on selected products across all categories, including electronics, fashion, and home essentials. This is your opportunity to enjoy premium-quality products at <mark>unbeatable</mark> prices.

Promotion Details:
- Discount: Up to 50% off on select items
- <mark>Validity</mark>: March 10 – March 31, 2025

Additional Benefits:
- Extra 10% discount for members using promo code SPRING10
- <mark>Complimentary shipping</mark> on orders exceeding $50
- Buy 2, Get 1 Free on select <mark>apparel</mark> and accessories

Terms & Conditions:
- This promotion is valid <mark>exclusively</mark> for online purchases at www.springdeals.com.
- The discount is automatically applied at checkout—<mark>no manual entry required</mark>.
- Some exclusions may apply, including brand-restricted items and newly released products.
- This offer cannot be combined with other promotions, and discounted items are <mark>final sale</mark> (non-refundable and non-exchangeable).
- All orders must be completed by 11:59 PM (PST) on March 31, 2025, to qualify for the discount.

For further inquiries, please contact our Customer Service Team at support@springdeals.com or call us at +1 (800) 555-0199.

Don't miss out! This exclusive promotion is available for a limited time only.

Best regards,
Spring Deals Team`,

  translation: `제목: 특별 혜택 - 한정 기간 봄 프로모션!

고객님께,

봄 세일 이벤트를 안내해 드립니다. 전자제품, 패션, 생활용품 등 모든 카테고리의 선별된 제품에 대해 최대 50% 할인을 제공합니다. 최고 품질의 제품을 최저가로 만나보실 수 있는 기회입니다.

프로모션 상세:
할인: 선별 상품 최대 50% 할인
유효기간: 2025년 3월 10일 - 3월 31일
추가 혜택:

회원 대상 프로모션 코드 SPRING10 사용 시 추가 10% 할인
$50 이상 구매 시 무료 배송
의류 및 액세서리 선별 상품 2+1 무료

이용약관:
본 프로모션은 www.springdeals.com 온라인 구매에만 적용됩니다.
할인은 결제 시 자동 적용되며 수동 입력이 필요하지 않습니다.
브랜드 제한 품목 및 신제품 등 일부 제외 상품이 있을 수 있습니다.
본 혜택은 다른 프로모션과 중복 적용이 불가하며, 할인 상품은 최종 판매됩니다(환불 및 교환 불가).
할인 적용을 위해서는 2025년 3월 31일 오후 11시 59분(PST)까지 주문을 완료해야 합니다.

문의사항이 있으시면 고객서비스팀(support@springdeals.com 또는 +1 (800) 555-0199)으로 연락 주시기 바랍니다.

놓치지 마세요! 이 특별 프로모션은 한정된 기간 동안만 제공됩니다.

감사합니다.
Spring Deals 팀`,

  koreanNouns: `Subject: Exclusive Offer – Limited-Time Spring Promotion!

Dear Valued Customer,

We are pleased to announce our Spring Savings Event, offering exclusive discounts of up to 50% on selected products all categories, including electronics, fashion, and home essentials. This is your opportunity to enjoy premium-quality products at <mark>최고의</mark> prices.

Promotion Details:
Discount: Up to 50% off on select items
<mark>유효기간</mark>: March 10 – March 31, 2025
Additional Benefits:

Extra 10% discount for members using promo code SPRING10
<mark>무료 배송</mark> on orders exceeding $50
Buy 2, Get 1 Free on select <mark>의류</mark> and accessories

Terms & Conditions:
This promotion is valid <mark>독점적으로</mark> for online purchases at www.springdeals.com.
The discount is automatically applied at checkout—<mark>수동 입력 불필요</mark>.
Some exclusions may apply, including brand-restricted items and newly released products.
This offer cannot be combined with other promotions, and discounted items are <mark>최종 판매</mark> (non-refundable and non-exchangeable).
All orders must be completed by 11:59 PM (PST) on March 31, 2025, to qualify for the discount.

For further inquiries, please contact our Customer Service Team at support@springdeals.com or call us at +1 (800) 555-0199.

Don't miss out! This exclusive promotion is available for a limited time only.

Best regards,
Spring Deals Team`,

  wordPairs: {
    전체: "all",
    최고의: "unbeatable",
    유효기간: "validity",
    "무료 배송": "complimentary shipping",
    의류: "apparel",
    독점적으로: "exclusively",
    "수동 입력 불필요": "no manual entry required",
    "최종 판매": "final sale",
  },

  questions: [],
};
const advertisement5 = {
  id: 5,
  passage: `Subject: Premier Executive Cleaning Services – Professional Home & Office Cleaning

Keeping your home and office <mark>spotless</mark> has never been easier! Premier Executive Cleaning Services provides high-quality, professional cleaning solutions tailored to meet the needs of busy professionals, homeowners, and <mark>corporate offices</mark>. Our trained specialists ensure a <mark>thorough</mark>, <mark>hygienic</mark> cleaning experience using eco-friendly, non-toxic products that are safe for your family and employees.

Why Choose Premier Executive Cleaning Services?
✔ <mark>Comprehensive</mark> Cleaning Packages – Choose from daily, weekly, or one-time deep cleaning services.
✔ Trained & Insured Professionals – Our expert cleaners are certified, background-checked, and insured.
✔ Flexible Scheduling – Book appointments at your convenience, including evenings and weekends.
✔ Satisfaction Guaranteed – If you're not completely satisfied, we'll reclean the area at no additional cost.

Special Promotion – Limited Time Offer!
 Offer Valid Until: March 31, 2025
 Exclusive 20% Discount for first-time customers (Use code: CLEAN20 at checkout)
 Free sanitization service for bookings over $100

How to Book?
 Call us at: +1 (800) 555-2098
 Visit our website: www.premierclean.com and schedule your service in minutes!
 Email inquiries: support@premierclean.com

Transform your space with our professional cleaning services today`,

  translation: `제목: 프리미어 이그제큐티브 청소 서비스 - 전문 주택 및 사무실 청소

집과 사무실을 깨끗하게 유지하는 것이 이보다 쉬웠던 적이 없습니다! 프리미어 이그제큐티브 청소 서비스는 바쁜 전문직 종사자, 주택 소유자, 기업 사무실의 요구를 충족시키는 맞춤형 고품질 전문 청소 솔루션을 제공합니다. 저희의 훈련된 전문가들은 가족과 직원들에게 안전한 친환경, 무독성 제품을 사용하여 철저하고 위생적인 청소 경험을 보장합니다.

프리미어 이그제큐티브 청소 서비스를 선택해야 하는 이유?
✔ 포괄적인 청소 패키지 - 일일, 주간 또는 일회성 딥클리닝 서비스 중 선택하세요.
✔ 훈련받고 보험에 가입된 전문가 - 저희 전문 청소부는 인증받았으며, 신원조회를 마쳤고, 보험에 가입되어 있습니다.
✔ 유연한 일정 관리 - 저녁과 주말을 포함하여 편리한 시간에 예약하세요.
✔ 만족 보장 - 완전히 만족하지 않으시면, 추가 비용 없이 해당 구역을 재청소해 드립니다.

특별 프로모션 - 한정 시간 제공!
제공 기간: 2025년 3월 31일까지
첫 이용 고객 전용 20% 할인 (결제 시 코드: CLEAN20 사용)
100달러 이상 예약 시 무료 살균 서비스

예약 방법
전화: +1 (800) 555-2098
웹사이트: www.premierclean.com에서 몇 분 만에 서비스를 예약하세요!
이메일 문의: support@premierclean.com

오늘 저희의 전문 청소 서비스로 공간을 변화시켜 보세요`,

  koreanNouns: `Subject: Premier Executive Cleaning Services – Professional Home & Office Cleaning

Keeping your home and office <mark>깨끗한</mark> has never been easier! Premier Executive Cleaning Services provides high-quality, professional cleaning solutions tailored to meet the needs of busy professionals, homeowners, and <mark>기업 사무실</mark>. Our trained specialists ensure a <mark>철저한</mark>, <mark>위생적인</mark> cleaning experience using eco-friendly, non-toxic products that are safe for your family and employees.

Why Choose Premier Executive Cleaning Services?
✔ <mark>포괄적인</mark> Cleaning Packages – Choose from daily, weekly, or one-time deep cleaning services.
✔ Trained & Insured Professionals – Our expert cleaners are certified, background-checked, and insured.
✔ Flexible Scheduling – Book appointments at your convenience, including evenings and weekends.
✔ Satisfaction Guaranteed – If you're not completely satisfied, we'll reclean the area at no additional cost.

Special Promotion – Limited Time Offer!
Offer Valid Until: March 31, 2025
Exclusive 20% Discount for first-time customers (Use code: CLEAN20 at checkout)
Free sanitization service for bookings over $100

How to Book?
Call us at: +1 (800) 555-2098
Visit our website: www.premierclean.com and schedule your service in minutes!
Email inquiries: support@premierclean.com

Transform your space with our professional cleaning services today`,

  wordPairs: {
    깨끗한: "spotless",
    "기업 사무실": "corporate offices",
    철저한: "thorough",
    위생적인: "hygienic",
    포괄적인: "comprehensive",
  },

  questions: [],
};
const advertisement6 = {
  id: 6,
  passage: `Subject: Now Hiring – <mark>Sales Associate</mark> Position Available

BrightMart, a leading retail company, is looking for a motivated <mark>Sales Associate</mark> to join our team. If you have excellent communication skills and a passion for customer service, we want to hear from you!

Job Responsibilities:

Assist customers with product inquiries and purchases
Maintain store displays and ensure a clean shopping environment
Process transactions and handle customer returns

Qualifications:

High school <mark>diploma</mark> or <mark>equivalent</mark>
Strong <mark>interpersonal skills</mark> and a friendly attitude
Previous <mark>retail experience</mark> <mark>preferred</mark> but not required
We offer competitive <mark>hourly wages</mark>, employee discounts, and opportunities for career advancement.

Interested <mark>candidates</mark> should apply online at www.brightmartcareers.com by August 15.

Join us and become part of a dynamic team today!`,

  translation: `제목: 채용 공고 - 판매 직원 모집

선도적인 소매 기업 브라이트마트에서 열정적인 판매 직원을 모집합니다. 뛰어난 의사소통 능력과 고객 서비스에 대한 열정이 있다면 지원해 주세요!

업무 책임:

상품 문의 및 구매 시 고객 지원
매장 진열대 관리 및 깨끗한 쇼핑 환경 유지
거래 처리 및 고객 반품 처리

자격 요건:

고등학교 졸업장 또는 동등한 자격
뛰어난 대인관계 능력과 친근한 태도
소매 경험 우대 (필수 아님)
경쟁력 있는 시급, 직원 할인 혜택, 그리고 경력 발전의 기회를 제공합니다.

관심 있는 지원자는 8월 15일까지 www.brightmartcareers.com에서 온라인으로 지원해 주시기 바랍니다.

지금 지원하여 역동적인 팀의 일원이 되세요!`,
  koreanNouns: `Subject: Now Hiring – <mark>판매 직원</mark> Position Available

BrightMart, a leading retail company, is looking for a motivated <mark>판매 직원</mark> to join our team. If you have excellent communication skills and a passion for customer service, we want to hear from you!

Job Responsibilities:

Assist customers with product inquiries and purchases
Maintain store displays and ensure a clean shopping environment
Process transactions and handle customer returns

Qualifications:

High school <mark>졸업장</mark> or <mark>동등한 자격</mark>
Strong <mark>대인관계 능력</mark> and a friendly attitude
Previous <mark>소매 경험</mark> <mark>우대</mark> but not required
We offer competitive hourly <mark>시급</mark>, employee discounts, and opportunities for career advancement.

Interested <mark>지원자</mark> should apply online at www.brightmartcareers.com by August 15.

Join us and become part of a dynamic team today!`,

  wordPairs: {
    "판매 직원": "Sales Associate",
    졸업장: "diploma",
    "동등한 자격": "equivalent",
    "대인관계 능력": "interpersonal skills",
    "소매 경험": "retail experience",
    시급: "hourly wages",
    지원자: "candidates",
    우대: "preferred",
  },

  questions: [],
};

const advertisement7 = {
  id: 7,
  passage: `Elite Business Language Training – Professional Language Courses for <mark>Corporate Teams</mark>
  
With the increasing <mark>demand</mark> for multilingual communication in global business, Elite Business Language Training provides <mark>customized</mark> corporate language courses designed for professionals seeking to enhance their business communication skills. Our <mark>expert</mark> instructors specialize in <mark>industry-specific</mark> vocabulary, ensuring that employees can communicate confidently in meetings, negotiations, and presentations.

The advantage of Elite Business Language Training is that courses are <mark>tailored</mark> to corporate needs, offering flexible scheduling options, including <mark>on-site</mark> training, live virtual classes, and <mark>self-paced</mark> online modules. Additionally, our programs <mark>integrate</mark> real-world business scenarios, enabling professionals to apply their learning immediately.

To further support companies investing in language training, we offer <mark>corporate discounts</mark> for teams of five or more employees. For a limited time, businesses enrolling before March 31, 2025, can receive a 15% discount on the first training package.

Find out how Elite Business Language Training can improve workplace efficiency and global business interactions by visiting our website at www.elitebusinesslanguage.com. Our team will respond to inquiries <mark>within</mark> 24 hours, and a consultation can be scheduled to assess your company's language training needs.

Call us today at (800) 555-1023 and give your team the competitive edge of multilingual communication!`,

  translation: `엘리트 비즈니스 언어 교육 - 기업팀을 위한 전문 언어 과정
글로벌 비즈니스에서 다국어 의사소통의 수요가 증가함에 따라, 엘리트 비즈니스 언어 교육은 비즈니스 의사소통 능력 향상을 원하는 전문가를 위한 맞춤형 기업 언어 과정을 제공합니다. 저희의 전문 강사진은 산업별 특화 어휘를 전문으로 하여, 직원들이 회의, 협상, 프레젠테이션에서 자신감 있게 의사소통할 수 있도록 보장합니다.

엘리트 비즈니스 언어 교육의 장점은 현장 교육, 실시간 가상 수업, 자율 학습 온라인 모듈을 포함한 유연한 일정 옵션을 제공하며 기업의 요구에 맞춤화된 과정이라는 것입니다. 또한, 저희 프로그램은 실제 비즈니스 시나리오를 통합하여 전문가들이 배운 내용을 즉시 적용할 수 있도록 합니다.

언어 교육에 투자하는 기업을 더욱 지원하기 위해, 5인 이상의 직원 팀에게 기업 할인을 제공합니다. 한정된 기간 동안, 2025년 3월 31일 이전에 등록하는 기업은 첫 번째 교육 패키지에 대해 15% 할인을 받을 수 있습니다.

엘리트 비즈니스 언어 교육이 어떻게 직장 효율성과 글로벌 비즈니스 상호작용을 개선할 수 있는지 www.elitebusinesslanguage.com에서 확인하세요. 저희 팀은 24시간 이내에 문의에 응답하며, 귀사의 언어 교육 필요성을 평가하기 위한 상담 일정을 잡을 수 있습니다.

지금 바로 (800) 555-1023으로 전화하셔서 귀사의 팀에게 다국어 의사소통의 경쟁력을 제공하세요!`,
  koreanNouns: `엘리트 – Professional Language Courses for <mark>기업팀</mark>

With the increasing <mark>수요</mark> for multilingual communication in global business, 엘리트 provides <mark>맞춤형</mark> corporate language courses designed for professionals seeking to enhance their business communication skills. Our <mark>전문</mark> instructors specialize in <mark>산업별 특화</mark> vocabulary, ensuring that employees can communicate confidently in meetings, negotiations, and presentations.

The advantage of 엘리트 is that courses are <mark>맞춤화된</mark> to corporate needs, offering flexible scheduling options, including <mark>현장</mark> training, live virtual classes, and <mark>자율 학습</mark> online modules. Additionally, our programs <mark>통합</mark> real-world business scenarios, enabling professionals to apply their learning immediately.

To further support companies investing in language training, we offer <mark>기업 할인</mark> for teams of five or more employees. For a limited time, businesses enrolling before March 31, 2025, can receive a 15% discount on the first training package.

Find out how 엘리트 can improve workplace efficiency and global business interactions by visiting our website at www.elitebusinesslanguage.com. Our team will respond to inquiries <mark>이내</mark> 24 hours, and a consultation can be scheduled to assess your company's language training needs.

Call us today at (800) 555-1023 and give your team the competitive edge of multilingual communication!`,
  wordPairs: {
    엘리트: "Elite Business Language Training(프로그램이름)",
    기업팀: "Corporate Teams",
    수요: "demand",
    맞춤형: "customized",
    전문: "expert",
    "산업별 특화": "industry-specific",
    맞춤화된: "tailored",
    현장: "on-site",
    "자율 학습": "self-paced",
    통합: "integrate",
    "기업 할인": "corporate discounts",
    이내: "within",
  },

  questions: [],
};

const advertisement8 = {
  id: 8,
  passage: `Elevate Workspace Solutions – Premium Office Rental & Co-Working Spaces

Finding the perfect workspace has never been easier. Elevate Workspace Solutions offers fully furnished office spaces and premium co-working environments designed for freelancers, startups, and <mark>established businesses</mark> seeking a professional and productive setting. Our offices provide high-speed internet, private meeting rooms, <mark>24/7 access</mark>, and <mark>flexible</mark> leasing options, ensuring that you have everything you need to focus on your work and grow your business.

The advantage of choosing Elevate Workspace Solutions is flexibility. Unlike traditional office leases, our <mark>month-to-month rental plans</mark> allow businesses to <mark>scale</mark> as needed. Additionally, members gain access to networking events, business workshops, and exclusive <mark>corporate perks</mark>.

For a limited time, new members who sign up before April 15, 2025, will receive one month of free rent on private office spaces and a 20% discount on co-working memberships.

To schedule a tour of our facilities, visit our website at www.elevateworkspace.com or contact our client services team at support@elevateworkspace.com. Our representatives are available to assist you <mark>seven days a week</mark>.

Call us today at (800) 555-3057 and discover how Elevate Workspace Solutions can transform your work environment!`,

  translation: `엘리베이트 워크스페이스 솔루션 - 프리미엄 사무실 임대 및 공유 오피스 공간

완벽한 업무 공간을 찾는 것이 이보다 쉬웠던 적이 없습니다. 엘리베이트 워크스페이스 솔루션은 프리랜서, 스타트업, 그리고 전문적이고 생산적인 환경을 찾는 기존 기업을 위해 설계된 완비된 사무실 공간과 프리미엄 공유 업무 환경을 제공합니다. 저희 사무실은 고속 인터넷, 개인 회의실, 24/7 출입, 유연한 임대 옵션을 제공하여 업무에 집중하고 비즈니스를 성장시키는 데 필요한 모든 것을 보장합니다.
엘리베이트 워크스페이스 솔루션을 선택하는 장점은 유연성입니다. 전통적인 사무실 임대와 달리, 저희의 월별 임대 계획은 기업이 필요에 따라 규모를 조정할 수 있게 해줍니다. 또한, 회원들은 네트워킹 이벤트, 비즈니스 워크샵, 그리고 독점적인 기업 혜택을 이용할 수 있습니다.
한정된 기간 동안, 2025년 4월 15일 이전에 가입하는 신규 회원은 개인 사무실 공간 1개월 무료 임대와 공유 오피스 멤버십 20% 할인을 받을 수 있습니다.
시설 투어 일정을 잡으시려면 웹사이트 www.elevateworkspace.com을 방문하시거나 고객 서비스 팀(support@elevateworkspace.com)에 문의해 주세요. 저희 담당자들이 주 7일 도움을 드릴 수 있습니다.
지금 바로 (800) 555-3057로 전화하셔서 엘리베이트 워크스페이스 솔루션이 어떻게 귀하의 업무 환경을 변화시킬 수 있는지 확인해보세요!`,

  koreanNouns: `상품E – Premium Office Rental & Co-Working Spaces

  Finding the perfect workspace has never been easier. 상품E offers fully furnished office spaces and premium co-working environments designed for freelancers, startups, and <mark>기존 기업</mark> seeking a professional and productive setting. Our offices provide high-speed internet, private meeting rooms, <mark>24시간 연중무휴 출입</mark>, and <mark>유연한</mark> leasing options, ensuring that you have everything you need to focus on your work and grow your business.

The advantage of choosing 상품E is flexibility. Unlike traditional office leases, our <mark>월별 임대 계획</mark> allow businesses to <mark>규모 조정</mark> as needed. Additionally, members gain access to networking events, business workshops, and exclusive <mark>기업 혜택</mark>.

For a limited time, new members who sign up before April 15, 2025, will receive one month of free rent on private office spaces and a 20% discount on co-working memberships.

To schedule a tour of our facilities, visit our website at www.elevateworkspace.com or contact our client services team at support@elevateworkspace.com. Our representatives are available to assist you <mark>주 7일</mark>.

Call us today at (800) 555-3057 and discover how 상품E can transform your work environment!`,

  wordPairs: {
    "기존 기업": "established businesses",
    "24시간 연중무휴 출입": "24/7 access",
    유연한: "flexible",
    "월별 임대 계획": "month-to-month rental plans",
    "규모 조정": "scale",
    "기업 혜택": "corporate perks",
    "주 7일": "seven days a week",
    상품E: "Elevate Workspace Solutions(회사이름)",
  },

  questions: [],
};

const advertisement9 = {
  id: 9,
  passage: `Subject: Premium Gym Membership – Special <mark>Enrollment</mark> Offer

Are you ready to achieve your fitness goals? Titan Fitness Club is offering a 3-month membership <mark>extension</mark> for <mark>free</mark> to new members who enroll by September 15.

Membership Benefits:
  Access to all Titan Fitness locations <mark>nationwide</mark>
  Complimentary one-on-one personal training session
  Unlimited access to yoga and <mark>strength training</mark> classes

Terms and Conditions:

To be <mark>eligible</mark>, members must sign up for a 12-month contract.
  Free membership extension is only available to new members.
  Offer is not <mark>applicable</mark> to <mark>month-to-month</mark> plans.
  Cancellations before 6 months will result in a $100 <mark>early termination</mark> fee.
  Important: This offer is subject to availability, and enrollment may close early if <mark>maximum capacity</mark> is reached.

Secure your spot today at www.titanfitness.com or call (555) 678-1234 for more details.`,

  translation: `제목: 프리미엄 헬스장 회원권 - 특별 등록 혜택

피트니스 목표를 달성할 준비가 되셨나요? 타이탄 피트니스 클럽에서 9월 15일까지 등록하는 신규 회원에게 3개월 회원권 연장을 무료로 제공합니다.

회원 혜택:
전국 모든 타이탄 피트니스 지점 이용 가능
1:1 개인 트레이닝 세션 무료 제공
요가 및 근력 운동 수업 무제한 이용

이용 약관:

자격 요건으로 12개월 계약에 가입해야 합니다.
무료 회원권 연장은 신규 회원에게만 제공됩니다.
월간 이용권에는 해당 혜택이 적용되지 않습니다.
6개월 이전 해지 시 100달러의 조기 해지 수수료가 부과됩니다.
중요 사항: 이 혜택은 수용 인원에 따라 달라질 수 있으며, 최대 수용 인원 도달 시 조기 마감될 수 있습니다.

오늘 바로 www.titanfitness.com에서 등록하시거나 자세한 내용은 (555) 678-1234로 문의하세요.`,
  koreanNouns: `Subject: Premium Gym Membership – Special <mark>등록</mark> Offer

Are you ready to achieve your fitness goals? Titan Fitness Club is offering a 3-month membership <mark>연장</mark> for free to new members who enroll by September 15.

Membership Benefits:
  Access to all Titan Fitness locations <mark>전국</mark>
  <mark>무료</mark> one-on-one personal training session
  Unlimited access to yoga and <mark>근력 운동</mark> classes

Terms and Conditions:

  To be <mark>자격이 있는</mark>, members must sign up for a 12-month contract.
  Free membership extension is only available to new members.
  Offer is not <mark>적용</mark> to <mark>월별</mark> plans.
  Cancellations before 6 months will result in a $100 <mark>조기 해지</mark> fee.
  Important: This offer is subject to availability, and enrollment may close early if <mark>최대 수용</mark> is reached.

Secure your spot today at www.titanfitness.com or call (555) 678-1234 for more details.`,

  wordPairs: {
    등록: "enrollment",
    연장: "extension",
    전국: "nationwide",
    무료: "free",
    "근력 운동": "strength training",
    "자격이 있는": "eligible",
    적용: "applicable",
    월별: "month-to-month",
    "조기 해지": "early termination",
    "최대 수용": "maximum capacity",
  },

  questions: [],
};

const advertisement10 = {
  id: 10,
  passage: `Don't Miss the Ultimate Live Music Experience!
Subject: Exclusive Pre-Sale – Limited Tickets Available!

Get ready for an <mark>unforgettable</mark> night of music and entertainment! Harmony Live 2025, featuring some of the world's top artists, will take place on Saturday, October 12 at Grand Arena.

Headliners: Grammy-winning artists & special guest performances

Ticket Categories:
- VIP Package: Front-row seating, backstage pass, complimentary drinks
- General Admission: Early entry & access to all main stage performances
- Group Discounts: Save 10% when purchasing 4 or more tickets

Exclusive Pre-Sale Offer:
- Pre-sale begins Monday, July 1 at 10:00 AM (PST).
- Only the first 500 buyers will receive a 20% discount on VIP tickets.
- This offer is available online only and will end on July 3 or when tickets sell out.

Important Notice:
- All tickets are non-refundable and <mark>non-transferable</mark>.
- VIP and General Admission tickets are available on a <mark>first-come, first-served</mark> basis.
- Prices will increase after July 3, so <mark>secure</mark> your tickets now!

Act now! Visit www.harmonylive.com to purchase your tickets before they're gone.`,

  translation: `최고의 라이브 음악 경험을 놓치지 마세요!
제목: 독점 사전 판매 - 한정 티켓 판매!

잊을 수 없는 음악과 엔터테인먼트의 밤을 준비하세요! 세계 최고의 아티스트들이 출연하는 하모니 라이브 2025가 10월 12일 토요일 그랜드 아레나에서 개최됩니다.

헤드라이너: 그래미상 수상 아티스트들과 특별 게스트 공연

티켓 카테고리:
VIP 패키지: 최전열 좌석, 백스테이지 패스, 무료 음료
일반 입장권: 조기 입장 및 모든 메인 스테이지 공연 관람 가능
단체 할인: 4매 이상 구매 시 10% 할인

독점 사전 판매 혜택:
사전 판매는 7월 1일 월요일 오전 10시(PST)에 시작됩니다.
첫 500명의 구매자에게만 VIP 티켓 20% 할인을 제공합니다.
이 혜택은 온라인에서만 가능하며 7월 3일 또는 티켓 매진 시 종료됩니다.

중요 공지:
모든 티켓은 환불 및 양도가 불가능합니다.
VIP와 일반 입장권은 선착순으로 제공됩니다.
7월 3일 이후에는 가격이 인상되니 지금 바로 티켓을 확보하세요!
지금 바로 행동하세요! www.harmonylive.com에서 티켓이 매진되기 전에 구매하세요.`,

  koreanNouns: `Don't Miss the Ultimate Live Music Experience!
Subject: Exclusive Pre-Sale – Limited Tickets Available!

Get ready for an <mark>잊을 수 없는</mark> night of music and entertainment! Harmony Live 2025, featuring some of the world's top artists, will take place on Saturday, October 12 at Grand Arena.

Headliners: Grammy-winning artists & special guest performances

Ticket Categories:
- VIP Package: Front-row seating, backstage pass, complimentary drinks
- General Admission: Early entry & access to all main stage performances
- Group Discounts: Save 10% when purchasing 4 or more tickets

Exclusive Pre-Sale Offer:
- Pre-sale begins Monday, July 1 at 10:00 AM (PST).
- Only the first 500 buyers will receive a 20% discount on VIP tickets.
- This offer is available online only and will end on July 3 or when tickets sell out.

Important Notice:
- All tickets are non-refundable and <mark>양도 불가</mark>.
- VIP and General Admission tickets are available on a <mark>선착순</mark>.
- Prices will increase after July 3, so <mark>확보하세요</mark> your tickets now!
- Act now! Visit www.harmonylive.com to purchase your tickets before they're gone.`,

  wordPairs: {
    "잊을 수 없는": "unforgettable",
    "양도 불가": "non-transferable",
    선착순: "first-come, first-served",
    확보하세요: "secure",
  },

  questions: [],
};
const advertisement11 = {
  id: 11,
  passage: `Subject: Exclusive Offer – Stay & Save at Sunset Bay Resort

Looking for the perfect getaway? Sunset Bay Resort invites you to experience <mark>unparalleled</mark> luxury and relaxation with our exclusive summer promotion.

Enjoy world-class amenities including:
✔ Spacious ocean-view suites with private balconies
✔ <mark>Gourmet</mark> dining featuring international cuisine
✔ Complimentary access to our spa, infinity pool, and fitness center

Limited-Time Offer:
- Book a three-night stay and receive one additional night free.
- Offer valid for reservations made by August 15 and stays completed by September 30.
- Early check-in and late check-out available for an additional fee.

Important Notice:
- This promotion is <mark>subject to</mark> availability.
- Blackout dates apply during <mark>major holidays</mark>.
- Cancellation policy: A <mark>full refund</mark> is available if canceled at least 48 hours before check-in.

Don't miss this opportunity for the perfect vacation! Reserve your stay today at www.sunsetbayresort.com or call (555) 345-6789.`,

  translation: `제목: 특별 혜택 - 선셋 베이 리조트에서 머물며 절약하세요

완벽한 휴가를 찾고 계신가요? 선셋 베이 리조트에서 특별한 여름 프로모션과 함께 비교할 수 없는 럭셔리함과 휴식을 경험해보세요.

다음과 같은 세계적 수준의 편의시설을 즐기세요:
✔ 프라이빗 발코니가 있는 넓은 오션뷰 스위트룸
✔ 세계 각국의 요리를 선보이는 고급 다이닝
✔ 스파, 인피니티 풀, 피트니스 센터 무료 이용

한정 기간 혜택:
3박 예약 시 추가 1박 무료 제공
8월 15일까지 예약하고 9월 30일까지 투숙 완료 시 유효한 혜택
조기 체크인과 늦은 체크아웃은 추가 요금으로 이용 가능

중요 안내:
이 프로모션은 예약 가능 여부에 따라 달라질 수 있습니다.
주요 공휴일에는 제외 기간이 적용됩니다.
취소 정책: 체크인 48시간 전까지 취소하면 전액 환불이 가능합니다.
완벽한 휴가를 위한 이 기회를 놓치지 마세요! www.sunsetbayresort.com에서 오늘 바로 예약하시거나 (555) 345-6789로 전화하세요.`,

  koreanNouns: `Subject: Exclusive Offer – Stay & Save at Sunset Bay Resort

Looking for the perfect getaway? Sunset Bay Resort invites you to experience <mark>비교할 수 없는</mark> luxury and relaxation with our exclusive summer promotion.

Enjoy world-class amenities including:
✔ Spacious ocean-view suites with private balconies
✔ <mark>고급</mark> dining featuring international cuisine
✔ Complimentary access to our spa, infinity pool, and fitness center

Limited-Time Offer:
- Book a three-night stay and receive one additional night free.
- Offer valid for reservations made by August 15 and stays completed by September 30.
- Early check-in and late check-out available for an additional fee.

Important Notice:
- This promotion <mark>~에 따라 달라진다</mark> availability.
- Blackout dates apply during <mark>주요 공휴일</mark>.
- Cancellation policy: A <mark>전액 환불</mark> is available if canceled at least 48 hours before check-in.

Don't miss this opportunity for the perfect vacation! Reserve your stay today at www.sunsetbayresort.com or call (555) 345-6789.`,

  wordPairs: {
    "비교할 수 없는": "unparalleled",
    고급: "gourmet",
    "~에 따라 달라진다": "subject to",
    "주요 공휴일": "major holidays",
    "전액 환불": "full refund",
  },

  questions: [],
};
const advertisement12 = {
  id: 12,
  passage: `Subject: Now Hiring – <mark>Front Desk Receptionist</mark>

Sunset Bay Resort, a premier luxury hotel, is seeking a <mark>Front Desk Receptionist</mark> to join our team. If you have excellent communication skills and a passion for <mark>hospitality</mark>, we encourage you to apply.

Key Responsibilities:
- Greet guests and assist with check-in and check-out procedures
- Handle room reservations and process payments
- Provide information about <mark>hotel services</mark> and <mark>local attractions</mark>

Qualifications:
- High school <mark>diploma</mark> or equivalent
- Minimum one year of customer service experience (<mark>hospitality experience</mark> preferred)
- Strong multitasking and problem-solving skills
- <mark>Proficiency</mark> in English (additional languages are a plus)

Benefits & <mark>Perks</mark>:
- Competitive salary with <mark>performance-based</mark> bonuses
- Discounted stays at partner hotels
- Paid training and career growth opportunities
- Application Deadline: Applications must be submitted by July 31.

How to Apply: Send your <mark>resume</mark> and <mark>cover letter</mark> to careers@sunsetbayresort.com.

Join our team and be part of an <mark>exceptional</mark> hospitality experience!`,

  translation: `제목: 채용 공고 - 프론트 데스크 리셉셔니스트

최고급 럭셔리 호텔인 선셋 베이 리조트에서 프론트 데스크 리셉셔니스트를 모집합니다. 뛰어난 의사소통 능력과 호텔 서비스에 대한 열정이 있다면 지원해 주세요!

주요 업무:

고객 응대 및 체크인/체크아웃 절차 지원
객실 예약 처리 및 결제 업무
호텔 서비스와 주변 관광지 정보 제공

자격 요건:
고등학교 졸업장 또는 동등한 자격
최소 1년의 고객 서비스 경험 (호텔 서비스 경험 우대)
뛰어난 멀티태스킹 및 문제 해결 능력
영어 구사 능력 필수 (추가 언어 구사 시 우대)

혜택 및 특전:
성과 기반 보너스가 포함된 경쟁력 있는 급여
제휴 호텔 할인 숙박
유급 교육 및 경력 성장 기회
지원 마감: 7월 31일까지 지원서 제출
지원 방법: 이력서와 자기소개서를 careers@sunsetbayresort.com으로 보내주세요.

우리 팀의 일원이 되어 특별한 호텔 서비스 경험의 일부가 되어보세요!`,

  koreanNouns: `Subject: Now Hiring – <mark>프론트 데스크 직원</mark>

Sunset Bay Resort, a premier luxury hotel, is seeking a <mark>프론트 데스크 직원</mark> to join our team. If you have excellent communication skills and a passion for <mark>호텔 서비스</mark>, we encourage you to apply.

Key Responsibilities:
- Greet guests and assist with check-in and check-out procedures
- Handle room reservations and process payments
- Provide information about hotel services and <mark>주변 관광지</mark>

Qualifications:
- High school <mark>졸업장</mark> or equivalent
- Minimum one year of customer service experience (<mark>호텔 서비스 경험</mark> preferred)
- Strong multitasking and problem-solving skills
<mark>능숙한 구사</mark> in English (additional languages are a plus)

Benefits & <mark>특전</mark>:
- Competitive salary with <mark>성과 기반</mark> bonuses
- Discounted stays at partner hotels
- Paid training and career growth opportunities
- Application Deadline: Applications must be submitted by July 31.

How to Apply: Send your <mark>이력서</mark> and <mark>자기소개서</mark> to careers@sunsetbayresort.com.

Join our team and be part of an <mark>특별한</mark> hospitality experience!`,

  wordPairs: {
    "프론트 데스크 직원": "Front Desk Receptionist",
    "호텔 서비스": "hospitality",
    "주변 관광지": "local attractions",
    졸업장: "diploma",
    "호텔 서비스 경험": "hospitality experience",
    "능숙한 구사": "proficiency",
    특전: "perks",
    "성과 기반": "performance-based",
    이력서: "resume",
    자기소개서: "cover letter",
    특별한: "exceptional",
  },

  questions: [],
};

const advertisement13 = {
  id: 13,
  passage: `Swift Auto Rentals – Premium Car Rental Services

Whether you need a luxury sedan for a business trip, an SUV for a family vacation, or a compact car for <mark>daily commuting</mark>, Swift Auto Rentals offers a wide range of high-quality vehicles to suit your needs. Our <mark>fleet</mark> is regularly maintained to ensure safety, comfort, and performance, and we provide <mark>affordable</mark> rental options with flexible terms.

One of the key advantages of Swift Auto Rentals is our <mark>hassle-free</mark> booking process. Customers can reserve a vehicle online within minutes and choose from <mark>a variety of</mark> rental plans, including daily, weekly, and long-term leases. We also offer airport pickup and <mark>drop-off</mark> services, making travel more convenient than ever.

For a limited time, first-time customers who book before March 31, 2025, will receive a 15% discount on <mark>all</mark> rentals. Additionally, <mark>those renting</mark> for seven days or more will qualify for a free upgrade to the next vehicle category.

To explore our vehicle selection and make a reservation, visit www.swiftautorentals.com or contact our customer support team at support@swiftautorentals.com. We are available 24/7 to assist with your booking and provide recommendations based on your travel needs.

📞 Call us today at (800) 555-7021 and experience convenient, high-quality car rentals at <mark>unbeatable</mark> prices!`,

  translation: `스위프트 오토 렌탈 - 프리미엄 자동차 대여 서비스

비즈니스 출장을 위한 고급 세단, 가족 휴가를 위한 SUV, 또는 일상적인 출퇴근을 위한 소형차가 필요하신가요? 스위프트 오토 렌탈은 고객님의 필요에 맞는 다양한 고품질 차량을 제공합니다. 저희 차량은 안전성, 편안함, 성능을 보장하기 위해 정기적으로 관리되며, 유연한 조건으로 합리적인 대여 옵션을 제공합니다.

스위프트 오토 렌탈의 주요 장점 중 하나는 번거롭지 않은 예약 과정입니다. 고객님은 몇 분 안에 온라인으로 차량을 예약할 수 있으며, 일일, 주간, 장기 임대 등 다양한 대여 계획 중에서 선택하실 수 있습니다. 또한 공항 픽업 및 반납 서비스를 제공하여 여행이 더욱 편리해졌습니다.

한정된 기간 동안, 2025년 3월 31일 이전에 예약하시는 첫 방문 고객님께는 모든 대여에 대해 15% 할인을 제공해 드립니다. 추가로, 7일 이상 대여하시는 경우 무료로 상위 차량 등급으로 업그레이드 해드립니다.

차량 선택을 둘러보시고 예약하시려면 www.swiftautorentals.com을 방문하시거나 support@swiftautorentals.com으로 고객 지원팀에 문의해 주세요. 저희는 24시간 연중무휴로 예약을 도와드리며 고객님의 여행 필요에 따른 추천 서비스를 제공해 드립니다.

📞 지금 바로 (800) 555-7021로 전화하셔서 합리적인 가격으로 편리하고 고품질의 자동차 대여 서비스를 경험해보세요!`,

  koreanNouns: `Swift Auto Rentals – Premium Car Rental Services

Whether you need a luxury sedan for a business trip, an SUV for a family vacation, or a compact car for <mark>일상적인 출퇴근</mark>, Swift Auto Rentals offers a wide range of high-quality vehicles to suit your needs. Our <mark>차량</mark> is regularly maintained to ensure safety, comfort, and performance, and we provide <mark>합리적인</mark> rental options with flexible terms.

One of the key advantages of Swift Auto Rentals is our <mark>번거롭지 않은</mark> booking process. Customers can reserve a vehicle online within minutes and choose from <mark>다양한</mark> rental plans, including daily, weekly, and long-term leases. We also offer airport pickup and <mark>반납</mark> services, making travel more convenient than ever.

For a limited time, first-time customers who book before March 31, 2025, will receive a 15% discount on all rentals. Additionally, <mark>대여하시는 분</mark> for seven days or more will qualify for a free upgrade to the next vehicle category.

To explore our vehicle selection and make a reservation, visit www.swiftautorentals.com or contact our customer support team at support@swiftautorentals.com. We are available 24/7 to assist with your booking and provide recommendations based on your travel needs.

📞 Call us today at (800) 555-7021 and experience convenient, high-quality car rentals at unbeatable prices!`,

  wordPairs: {
    "일상적인 출퇴근": "daily commuting",
    차량: "fleet",
    합리적인: "affordable",
    "번거롭지 않은": "hassle-free",
    다양한: " a variety of",
    반납: "drop-off",
    "대여하시는 분": "those renting",
  },

  questions: [],
};
const advertisement14 = {
  id: 14,
  passage: `Trade & Treasure – Turn Your <mark>Unwanted</mark> Items into Cash!

Do you have old furniture, electronics, or clothing collecting dust? Trade & Treasure offers instant cash payments for your <mark>secondhand</mark> <mark>goods</mark>! With multiple locations <mark>across</mark> the city, our friendly staff will assess your items and provide you with cash or store credit <mark>on the spot</mark>.

Not only can you sell your used items, but you can also shop for amazing deals on quality secondhand goods. Our stores carry a wide selection of vintage clothing, home décor, <mark>refurbished electronics</mark>, and unique <mark>collectibles</mark>—all at prices far <mark>below retail value</mark>. With <mark>new inventory</mark> arriving daily, you'll never know what hidden gems you'll find!

Even better, 10% of our <mark>profits</mark> go directly to <mark>local community initiatives</mark>, helping <mark>fund</mark> education and job training programs for <mark>underprivileged youth</mark>. By shopping or selling with us, you're making a positive impact while saving money!

Visit a Trade & Treasure store today to earn cash, shop smart, and support your community! For more information, call (800) 555-2024 or visit www.tradeandtreasure.com.`,

  translation: `트레이드 & 트레저 - 불필요한 물건을 현금으로 바꾸세요!

오래된 가구, 전자제품 또는 옷이 먼지만 쌓이고 있나요? 트레이드 & 트레저는 중고 물품에 대해 즉시 현금을 지급해 드립니다! 도시 전역에 위치한 여러 매장에서 친절한 직원들이 고객님의 물품을 평가하고 현장에서 현금이나 매장 적립금을 제공해 드립니다.

중고 물품을 판매할 수 있을 뿐만 아니라, 품질 좋은 중고품을 놀라운 가격에 구매하실 수도 있습니다. 저희 매장은 빈티지 의류, 홈 데코, 리퍼브 전자제품, 독특한 수집품 등 다양한 상품을 소매가보다 훨씬 저렴한 가격에 제공합니다. 매일 새로운 상품이 입고되어 어떤 숨은 보물을 발견하게 될지 모릅니다!

더욱 좋은 점은, 저희 수익의 10%가 지역 사회 이니셔티브에 직접 기부되어 취약 계층 청소년을 위한 교육 및 직업 훈련 프로그램 지원에 사용된다는 것입니다. 저희와 함께 쇼핑하거나 판매하시면서 돈도 절약하고 긍정적인 영향도 미칠 수 있습니다!

오늘 트레이드 & 트레저 매장을 방문하여 현금도 벌고, 똑똑하게 쇼핑하고, 지역 사회도 지원하세요! 자세한 정보는 (800) 555-2024로 전화하시거나 www.tradeandtreasure.com을 방문해 주세요.`,
  koreanNouns: `Trade & Treasure – Turn Your <mark>불필요한</mark> Items into Cash!

Do you have old furniture, electronics, or clothing collecting dust? Trade & Treasure offers instant cash payments for your <mark>중고</mark> <mark>물품</mark>! With multiple locations <mark>전역에</mark> the city, our friendly staff will assess your items and provide you with cash or store credit <mark>현장에서</mark>.

Not only can you sell your used items, but you can also shop for amazing deals on quality <mark>중고</mark> <mark>물품</mark>. Our stores carry a wide selection of vintage clothing, home décor, <mark>수리된 전자제품</mark>, and unique <mark>수집품</mark>—all at prices far <mark>소매가 이하</mark>. With <mark>새로운 재고가</mark> arriving daily, you'll never know what hidden gems you'll find!

Even better, 10% of our <mark>수익</mark> go directly to <mark>지역 사회 이니셔티브</mark>, helping <mark>지원</mark> education and job training programs for <mark>취약 계층 청소년</mark>. By shopping or selling with us, you're making a positive impact while saving money!

Visit a Trade & Treasure store today to earn cash, shop smart, and support your community! For more information, call (800) 555-2024 or visit www.tradeandtreasure.com.`,

  wordPairs: {
    불필요한: "unwanted",
    중고: "secondhand",
    물품: "goods",
    전역에: "across",
    현장에서: "on the spot",
    "수리된 전자제품": "refurbished electronics",
    수집품: "collectibles",
    "소매가 이하": "below retail value",
    "새로운 재고가": "new inventory",
    수익: "profits",
    "지역 사회 이니셔티브": "local community initiatives",
    지원: "fund",
    "취약 계층 청소년": "underprivileged youth",
  },

  questions: [],
};

const advertisement15 = {
  id: 15,
  passage: `SpeedSell Auto – Instant Cash for Your Used Car!

Selling your car has never been easier. At SpeedSell Auto, we buy used cars of all <mark>makes</mark>, models, and conditions, offering fair market prices and <mark>same-day cash payments</mark>. Whether your car is <mark>nearly</mark> new, high-mileage, or in need of repairs, our team will provide you with a competitive offer on the spot.

Unlike <mark>private sales</mark> or dealership trade-ins that take time and negotiation, SpeedSell Auto ensures a fast and <mark>hassle-free process</mark>. Simply bring your vehicle to one of our locations, and after a quick evaluation, you'll receive an offer immediately. If you accept, you'll leave with cash in hand the same day. We handle all <mark>title transfers</mark> and paperwork, making the process <mark>effortless</mark> for you.

For a limited time, customers who sell their vehicle before April 30, 2025, will receive a $250 cash bonus if their car is <mark>valued</mark> over $5,000.

Visit SpeedSell Auto today or call (800) 555-8080 to find out how much your car is <mark>worth</mark>. Drive in, sell fast, and walk away with cash in minutes.`,

  translation: `스피드셀 오토 - 중고차를 즉시 현금으로!

이제 자동차 판매가 그 어느 때보다 쉬워졌습니다. 스피드셀 오토는 모든 제조사, 모델, 상태의 중고차를 구매하며, 공정한 시장 가격과 당일 현금 지급을 제공합니다. 귀하의 차량이 거의 새 차이든, 주행거리가 많든, 수리가 필요하든 상관없이, 저희 팀이 현장에서 경쟁력 있는 견적을 제공해 드립니다.

시간과 협상이 필요한 개인 거래나 딜러십 트레이드인과 달리, 스피드셀 오토는 빠르고 번거롭지 않은 프로세스를 보장합니다. 간단히 저희 지점 중 한 곳에 차량을 가져오시면, 신속한 평가 후 즉시 견적을 받으실 수 있습니다. 수락하시면 당일에 현금을 받고 가실 수 있습니다. 저희가 모든 소유권 이전과 서류 작업을 처리하여 귀하께서는 수고로움 없이 진행하실 수 있습니다.

한정된 기간 동안, 2025년 4월 30일 이전에 차량을 판매하시는 고객 중 차량 가치가 5,000달러 이상인 경우 250달러의 현금 보너스를 받으실 수 있습니다.

오늘 스피드셀 오토를 방문하시거나 (800) 555-8080으로 전화하셔서 귀하의 차량 가치를 확인해 보세요. 운전해서 오셔서, 빠르게 판매하고, 몇 분 만에 현금을 받고 가세요.`,
  koreanNouns: `SpeedSell Auto – Instant Cash for Your Used Car!

Selling your car has never been easier. At SpeedSell Auto, we buy used cars of all <mark>제조사</mark>, models, and conditions, offering fair market prices and <mark>당일 현금 지급</mark>. Whether your car is <mark>거의</mark> new, high-mileage, or in need of repairs, our team will provide you with a competitive offer on the spot.

Unlike <mark>개인 판매</mark> or dealership trade-ins that take time and negotiation, SpeedSell Auto ensures a fast and <mark>번거롭지 않은 프로세스</mark>. Simply bring your vehicle to one of our locations, and after a quick evaluation, you'll receive an offer immediately. If you accept, you'll leave with cash in hand the same day. We handle all <mark>소유권 이전</mark> and paperwork, making the process <mark>수고로움 없이</mark> for you.

For a limited time, customers who sell their vehicle before April 30, 2025, will receive a $250 cash bonus if their car is <mark>가치가</mark> over $5,000.

Visit SpeedSell Auto today or call (800) 555-8080 to find out how much your car is <mark>가치를</mark>. Drive in, sell fast, and walk away with cash in minutes.`,

  wordPairs: {
    제조사: "makes",
    "당일 현금 지급": "same-day cash payments",
    거의: "nearly",
    "개인 판매": "private sales",
    "번거롭지 않은 프로세스": "hassle-free process",
    "소유권 이전": "title transfers",
    "수고로움 없이": "effortless",
    가치가: "valued",
    가치를: "worth",
  },

  questions: [],
};

const advertisement16 = {
  id: 16,
  passage: `SwiftMove Relocation – Stress-Free Moving Services

Moving to a new home or office? SwiftMove Relocation takes the <mark>hassle</mark> out of <mark>moving</mark> with our fast, <mark>reliable</mark>, and <mark>affordable</mark> moving solutions. Whether you're relocating <mark>across town</mark> or to another city, our experienced <mark>movers</mark> handle packing, <mark>loading</mark>, transportation, and unpacking with the <mark>utmost</mark> care.

With our full-service moving packages, you don't have to lift a finger. We use protective wrapping and <mark>secure handling techniques</mark> to ensure your <mark>belongings</mark> arrive safely. We also offer temporary storage solutions for customers who need extra time before settling in.

For a limited time, customers booking a move before May 15, 2025, will receive 10% off total moving costs.

Make your next move effortless! Call (800) 555-9090 or visit www.swiftmoverelocation.com to schedule your move today.`,

  translation: `스위프트무브 이사 서비스 - 스트레스 없는 이사 서비스

새로운 집이나 사무실로 이사하시나요? 스위프트무브 이사 서비스는 빠르고, 신뢰할 수 있으며, 합리적인 가격의 이사 솔루션으로 이사의 번거로움을 덜어드립니다. 시내 이사든 다른 도시로의 이사든, 저희의 숙련된 이사 전문가들이 포장, 적재, 운송, 포장 해제를 최선을 다해 처리해 드립니다.

저희의 풀 서비스 이사 패키지를 이용하시면 손가락 하나 까딱하실 필요가 없습니다. 보호 포장재와 안전한 취급 기술을 사용하여 귀하의 소지품이 안전하게 도착하도록 보장합니다. 또한 정착하기 전 추가 시간이 필요한 고객을 위한 임시 보관 솔루션도 제공합니다.

한정된 기간 동안, 2025년 5월 15일 이전에 이사를 예약하시는 고객은 총 이사 비용의 10% 할인을 받으실 수 있습니다.

다음 이사를 수월하게 진행하세요! (800) 555-9090으로 전화하시거나 www.swiftmoverelocation.com을 방문하여 오늘 이사를 예약하세요.`,

  koreanNouns: `SwiftMove Relocation – Stress-Free Moving Services

Moving to a new home or office? SwiftMove Relocation takes the <mark>번거로움</mark> out of <mark>이사</mark> with our fast, <mark>믿을 수 있는</mark>, and <mark>저렴한</mark> moving solutions. Whether you're relocating <mark>시내</mark> or to another city, our experienced <mark>이사 전문가</mark> handle packing, <mark>적재</mark>, transportation, and unpacking with the <mark>최선의</mark> care.

With our full-service moving packages, you don't have to lift a finger. We use protective wrapping and <mark>안전한 취급 기술</mark> to ensure your <mark>소지품</mark> arrive safely. We also offer temporary storage solutions for customers who need extra time before settling in.

For a limited time, customers booking a move before May 15, 2025, will receive 10% off total moving costs.

Make your next move effortless! Call (800) 555-9090 or visit www.swiftmoverelocation.com to schedule your move today.`,

  wordPairs: {
    번거로움: "hassle",
    이사: "moving",
    "믿을 수 있는": "reliable",
    저렴한: "affordable",
    시내: "across town",
    "이사 전문가": "movers",
    적재: "loading",
    최선의: "utmost",
    "안전한 취급 기술": "secure handling techniques",
    소지품: "belongings",
  },

  questions: [],
};

const advertisement17 = {
  id: 17,
  passage: `Paws & Care – Premium Pet Boarding & Grooming Services

Going on vacation or a business trip? Paws & Care provides safe, comfortable, and fun <mark>pet boarding services</mark> for dogs and cats. Our facilities offer <mark>spacious</mark> <mark>kennels</mark>, daily exercise routines, and 24/7 <mark>veterinary support</mark> to keep your pet happy and healthy while you're away.

We also provide professional grooming services, ensuring your furry friend looks and feels their best. Whether it's a simple wash or a full grooming session, our trained specialists use pet-friendly products to give your pet the care they deserve.

For a limited time, first-time customers receive a free grooming session with any <mark>boarding stay</mark> of three nights or more.

Give your pet the best care! Call (800) 555-3030 or visit www.pawsandcare.com to book a stay.`,

  translation: `포즈 앤 케어 - 프리미엄 반려동물 호텔링 & 미용 서비스

휴가나 출장을 가시나요? 포즈 앤 케어는 강아지와 고양이를 위한 안전하고, 편안하며, 즐거운 반려동물 호텔링 서비스를 제공합니다. 저희 시설은 넓은 켄넬, 일일 운동 프로그램, 그리고 24시간 수의사 지원을 제공하여 귀하가 자리를 비운 동안 반려동물이 행복하고 건강하게 지낼 수 있도록 합니다.

또한 전문적인 미용 서비스를 제공하여 귀하의 털복숭이 친구가 최상의 모습과 기분을 느낄 수 있도록 합니다. 간단한 목욕이든 전체 미용이든, 저희의 훈련된 전문가들이 반려동물 친화적인 제품을 사용하여 귀하의 반려동물이 받아야 할 관리를 제공합니다.

한정된 기간 동안, 첫 방문 고객은 3박 이상 호텔링 이용 시 무료 미용 서비스를 받으실 수 있습니다.

반려동물에게 최고의 관리를 선물하세요! (800) 555-3030으로 전화하시거나 www.pawsandcare.com을 방문하여 예약하세요.`,

  koreanNouns: `Paws & Care – Premium Pet Boarding & Grooming Services

  Going on vacation or a business trip? Paws & Care provides safe, comfortable, and fun <mark>반려동물 호텔링 서비스</mark> for dogs and cats. Our facilities offer <mark>넓은</mark> <mark>켄넬</mark>, daily exercise routines, and 24/7 <mark>수의 의료 서비스</mark>to keep your pet happy and healthy while you're away.
  
  We also provide professional grooming services, ensuring your furry friend looks and feels their best. Whether it's a simple wash or a full grooming session, our trained specialists use pet-friendly products to give your pet the care they deserve.
  
  For a limited time, first-time customers receive a free grooming session with any <mark>호텔링</mark> of three nights or more.
  
  Give your pet the best care! Call (800) 555-3030 or visit www.pawsandcare.com to book a stay.`,

  wordPairs: {
    "반려동물 호텔링 서비스": "pet boarding services",
    넓은: "spacious",
    켄넬: "kennels",
    "수의 의료 서비스": "veterinary support",
    호텔링: "boarding stay",
  },

  questions: [],
};

const advertisement18 = {
  id: 18,
  passage: `Jericho <mark>Paralegal</mark> Service

We are looking for a proficient secretary for a local paralegal firm on West Wing Avenue.

A university degree or higher is required to qualify for this position. The <mark>duties</mark> include guiding clients, managing conference schedules, providing online and telephone customer service, and arranging documents. The successful candidate will also <mark>be skilled in</mark> the use of document editing software. The starting salary is $800 a month, and it can be further increased to $1,200 based on your output.

Kindly send your application to juliana@jerichoparalegal.com to be considered.`,

  translation: `제리코 법률 보조 서비스

웨스트 윙 애비뉴에 위치한 지역 법률 보조 회사에서 유능한 비서를 찾고 있습니다.

이 직책에 지원하기 위해서는 대학 학위 이상이 필요합니다. 업무는 고객 안내, 회의 일정 관리, 온라인 및 전화 고객 서비스 제공, 문서 정리 등이 포함됩니다. 성공적인 후보자는 문서 편집 소프트웨어 사용에도 능숙해야 합니다. 시작 급여는 월 800달러이며, 성과에 따라 1,200달러까지 인상될 수 있습니다.

지원을 원하시면 juliana@jerichoparalegal.com으로 지원서를 보내주시기 바랍니다.`,

  koreanNouns: `Jericho <mark>법률 보조</mark> Service

We are looking for a proficient secretary for a local paralegal firm on West Wing Avenue.

A university degree or higher is required to qualify for this position. The <mark>업무</mark> include guiding clients, managing conference schedules, providing online and telephone customer service, and arranging documents. The successful candidate will also <mark>능숙해야 합니다</mark> the use of document editing software. The starting salary is $800 a month, and it can be further increased to $1,200 based on your output.

Kindly send your application to juliana@jerichoparalegal.com to be considered.`,

  wordPairs: {
    Paralegal: "법률 보조",
    duties: "업무",
    "be skilled in": "능숙해야 합니다",
  },

  questions: [],
};

const advertisement19 = {
  id: 19,
  passage: `Villa Solara Vista

We are delighted to welcome you to Villa Solara Vista.

Our villa is located in close <mark>proximity</mark> to downtown Los Angeles, which is the business hub of California. Besides <mark>numerous</mark> leisure activities for business travelers, our villa provides a pleasant environment for business meetings, conferences, and <mark>corporate retreats</mark>.

At Villa Solara Vista, you or your team can tap into:
Eight soundproof meeting rooms.
Videoconferencing for virtual meetings.
<mark>On-demand</mark> workspaces and workstations.
Tour guide services.
Hiking and biking trails.
A superb spa, swimming pool, and sauna.
Fitness rooms and instructor-led exercise classes.
A restaurant specializing in Mediterranean cuisine.

Our villa <mark>stands out</mark> as the most <mark>spacious</mark> in the state, as it can <mark>accommodate</mark> as many as 60 people on any given day. Every room comes with a coffee maker, a restroom, and free high-speed Wi-Fi. Extra pieces of furniture and <mark>appliances</mark> are available on-demand around the clock.

Would you like to make a reservation? Call us toll-free on this number: (888) 168-8989. Reservations by phone are available from 8 a.m. to 8 p.m. PST Monday through Friday. You can also make your reservation 24/7 on our website: www.villasolaravista.com

Are you interested in becoming our premium member? Take part in our loyalty program and become eligible for a whopping 20% discount.

Make your next stay in LA truly memorable by reaching us today.`,

  translation: `빌라 솔라라 비스타

빌라 솔라라 비스타에 오신 것을 환영합니다.

저희 빌라는 캘리포니아의 비즈니스 중심지인 로스앤젤레스 다운타운에 가까이 위치해 있습니다. 비즈니스 여행객을 위한 다양한 여가 활동 외에도, 저희 빌라는 비즈니스 미팅, 컨퍼런스, 기업 연수를 위한 쾌적한 환경을 제공합니다.

빌라 솔라라 비스타에서 귀하나 귀하의 팀은 다음을 이용할 수 있습니다:

8개의 방음 회의실.

가상 회의를 위한 화상 회의 시설.

요청 시 제공되는 작업 공간 및 워크스테이션.

관광 가이드 서비스.

하이킹 및 자전거 트레일.

최고급 스파, 수영장, 사우나.

피트니스 룸 및 강사가 이끄는 운동 수업.

지중해 요리를 전문으로 하는 레스토랑.

저희 빌라는 하루에 최대 60명을 수용할 수 있어 주 내에서 가장 넓은 공간을 자랑합니다. 모든 객실에는 커피 메이커, 화장실, 무료 고속 Wi-Fi가 제공됩니다. 추가 가구 및 가전제품은 24시간 요청 시 이용 가능합니다.

예약을 원하시나요? 무료 전화번호 (888) 168-8989로 연락해 주세요. 전화 예약은 월요일부터 금요일까지 오전 8시부터 오후 8시(태평양 표준시)까지 가능합니다. 또한 저희 웹사이트 www.villasolaravista.com에서 24시간 예약하실 수 있습니다.

프리미엄 회원이 되는 데 관심이 있으신가요? 저희 로열티 프로그램에 참여하시고 20%의 큰 할인 혜택을 받으세요.

오늘 저희에게 연락하셔서 LA에서의 다음 숙박을 정말 기억에 남는 경험으로 만드세요.`,

  koreanNouns: `Villa Solara Vista

We are delighted to welcome you to Villa Solara Vista.

Our villa is located in close <mark>가까이</mark> to downtown Los Angeles, which is the business hub of California. Besides <mark>다양한</mark> leisure activities for business travelers, our villa provides a pleasant environment for business meetings, conferences, and <mark>기업 연수</mark>.

At Villa Solara Vista, you or your team can tap into:
Eight soundproof meeting rooms.
Videoconferencing for virtual meetings.
<mark>요청 시 제공되는</mark> workspaces and workstations.
Tour guide services.
Hiking and biking trails.
A superb spa, swimming pool, and sauna.
Fitness rooms and instructor-led exercise classes.
A restaurant specializing in Mediterranean cuisine.

Our villa <mark>자랑합니다</mark> as the most <mark>넓은</mark> in the state, as it can <mark>수용할 수 있어</mark> as many as 60 people on any given day. Every room comes with a coffee maker, a restroom, and free high-speed Wi-Fi. Extra pieces of furniture and <mark>가전제품</mark> are available on-demand around the clock.

Would you like to make a reservation? Call us toll-free on this number: (888) 168-8989. Reservations by phone are available from 8 a.m. to 8 p.m. PST Monday through Friday. You can also make your reservation 24/7 on our website: www.villasolaravista.com

Are you interested in becoming our premium member? Take part in our loyalty program and become eligible for a whopping 20% discount.

Make your next stay in LA truly memorable by reaching us today.`,

  wordPairs: {
    proximity: "가까움",
    numerous: "많은",
    "corporate retreats": "기업 연수",
    "On-demand": "요청 시 제공되는",
    "stands out": "자랑합니다",
    spacious: "넓은",
    accommodate: "수용하다",
    appliances: "가전제품",
  },

  questions: [],
};

const advertisement20 = {
  id: 20,
  passage: `Enjoy an <mark>Excursion</mark> in the Great Outdoors!

Are you ready for the great outdoors? We have a promo code for you: OUTDOORS. Use this promo code when booking a walking tour around Glacier National Park this month and get a free twin bedroom in a hotel in Columbia Falls, Montana, for your entire stay - with all <mark>meals</mark> included!

Walking tours at Glacier National Park are available from 9 a.m. to 5 p.m. Monday through Sunday. It's high time you enjoyed Montana's great wilderness and its <mark>outstanding</mark> natural beauty!

Please note that our promo code expires on February 15, that it doesn't apply to reservations made for children, and that it can't be used on top of other coupons.`,

  translation: `대자연에서의 여행을 즐기세요!

대자연을 위한 준비가 되셨나요? 여러분을 위한 프로모션 코드가 있습니다: OUTDOORS. 이번 달에 글레이셔 국립공원 주변 도보 투어를 예약할 때 이 프로모션 코드를 사용하시면 몬태나주 컬럼비아 폴스에 있는 호텔의 트윈 침실을 체류 기간 동안 무료로 이용하실 수 있으며 - 모든 식사가 포함됩니다!

글레이셔 국립공원의 도보 투어는 월요일부터 일요일까지 오전 9시부터 오후 5시까지 이용 가능합니다. 몬태나의 멋진 황야와 뛰어난 자연의 아름다움을 즐길 때가 되었습니다!

프로모션 코드는 2월 15일에 만료되며, 어린이를 위한 예약에는 적용되지 않고, 다른 쿠폰과 함께 사용할 수 없음을 참고해 주세요.`,
  koreanNouns: `Enjoy an <mark>여행</mark> in the Great Outdoors!

Are you ready for the great outdoors? We have a promo code for you: OUTDOORS. Use this promo code when booking a walking tour around Glacier National Park this month and get a free twin bedroom in a hotel in Columbia Falls, Montana, for your entire stay - with all <mark>식사</mark> included!

Walking tours at Glacier National Park are available from 9 a.m. to 5 p.m. Monday through Sunday. It's high time you enjoyed Montana's great wilderness and its <mark>뛰어난</mark> natural beauty!

Please note that our promo code expires on February 15, that it doesn't apply to reservations made for children, and that it can't be used on top of other coupons.`,

  wordPairs: {
    Excursion: "여행",
    meals: "식사",
    outstanding: "뛰어난",
  },

  questions: [],
};

const advertisement21 = {
  id: 21,
  passage: `Lunaria Style Inc.'s New Weekly Newsletter

We are pleased to inform you that we are now ready to send out our newsletter at least once every week. Instead of waiting for another <mark>issue</mark> of our monthly magazine, our customers will now be able to get the usual <mark>dose of entertainment</mark> and <mark>tap into</mark> the latest news about fashion and celebrities a lot more often. From now on, <mark>stay tuned</mark> for our emails with personalized stories every Monday morning.

Unless you have already done so, you can subscribe to our new weekly newsletter at www.lunariastyle.com. Upon receiving your request, we'll send you a quick confirmation email to verify the ownership of your email account. After you confirm your email address, you'll be redirected to a page where you'll be able to specify your preferred topics and headlines. Note that our new weekly newsletter will remain available only to those customers who have subscribed.`,

  translation: `루나리아 스타일 주식회사의 새로운 주간 뉴스레터

저희는 이제 최소 주 1회 뉴스레터를 발송할 준비가 되었음을 알려드립니다. 월간 잡지의 다음 호를 기다리는 대신, 저희 고객들은 이제 평소의 엔터테인먼트와 패션 및 유명인에 관한 최신 소식을 훨씬 더 자주 접하실 수 있습니다. 이제부터 매주 월요일 아침에 개인 맞춤형 스토리가 담긴 이메일을 기대해 주세요.

아직 구독하지 않으셨다면, www.lunariastyle.com에서 새로운 주간 뉴스레터를 구독하실 수 있습니다. 요청을 받은 후, 이메일 계정의 소유권을 확인하기 위한 빠른 확인 이메일을 보내드립니다. 이메일 주소를 확인하신 후에는 선호하는 주제와 헤드라인을 지정할 수 있는 페이지로 리디렉션됩니다. 새로운 주간 뉴스레터는 구독한 고객에게만 계속 제공된다는 점을 참고해 주세요.`,
  koreanNouns: `Lunaria Style Inc.'s New Weekly Newsletter

We are pleased to inform you that we are now ready to send out our newsletter at least once every week. Instead of waiting for another <mark>호</mark> of our monthly magazine, our customers will now be able to get the usual <mark>일정량의 즐거움</mark> and <mark>접하다</mark> the latest news about fashion and celebrities a lot more often. From now on, <mark>기대하다</mark> for our emails with personalized stories every Monday morning.

Unless you have already done so, you can subscribe to our new weekly newsletter at www.lunariastyle.com. Upon receiving your request, we'll send you a quick confirmation email to verify the ownership of your email account. After you confirm your email address, you'll be redirected to a page where you'll be able to specify your preferred topics and headlines. Note that our new weekly newsletter will remain available only to those customers who have subscribed.`,

  wordPairs: {
    issue: "호",
    "tap into": "접하다",
    "stay tuned": "계속 받아보세요",
    "dose of entertainment": "일정량의 즐거움",
  },

  questions: [],
};

const advertisement22 = {
  id: 22,
  passage: `Sierra International Law Academy

If you are <mark>in search of</mark> a degree in international law, look no further than Sierra International Law Academy.

A new academic year begins this September, and the school offers a wide range of courses in various branches of international law, such as international <mark>criminal law</mark>, <mark>world trade law</mark>, international environmental law, and more. The classes are taught by <mark>renowned</mark> lawyers and lecturers with <mark>vast</mark> experience in the field of international law. Upon completing a four-year educational program, students are granted not only an international law degree, but also an internship at one of the international law firms that Sierra International Law Academy has an internship <mark>affiliation</mark> agreement with. This internship program has made the institution one of the top law schools in the country.

The tuition at Sierra International Law Academy is $8,000 for local residents and $28,000 for out-of-state students. However, you can become <mark>entitled to</mark> 10% off your annual tuition if you use the promo code "FREE LAW" when applying to Sierra International Law Academy. Enrollment takes place <mark>throughout</mark> the first few weeks of August, so be sure to submit your application no later than August 8. Please note that a number of scholarships as well as research grants are available at Sierra International Law Academy to local and international students alike.

For more information about the courses and opportunities offered by Sierra International Law Academy, visit the school's website: www.sierraintlaw.edu.`,

  translation: `시에라 국제법 아카데미

국제법 학위를 찾고 계신다면, 시에라 국제법 아카데미만큼 좋은 곳은 없습니다.

새 학년은 올해 9월에 시작되며, 학교는 국제 형법, 세계 무역법, 국제 환경법 등 국제법의 다양한 분야에서 광범위한 과정을 제공합니다. 수업은 국제법 분야에서 풍부한 경험을 가진 저명한 변호사와 강사들이 가르칩니다. 4년간의 교육 프로그램을 마치면 학생들은 국제법 학위뿐만 아니라 시에라 국제법 아카데미가 인턴십 제휴 계약을 맺은 국제 법률 회사 중 하나에서 인턴십 기회도 얻게 됩니다. 이 인턴십 프로그램은 이 기관을 국내 최고의 법학 학교 중 하나로 만들었습니다.

시에라 국제법 아카데미의 학비는 지역 주민의 경우 $8,000, 타주 학생의 경우 $28,000입니다. 그러나 시에라 국제법 아카데미에 지원할 때 프로모션 코드 "FREE LAW"를 사용하면 연간 학비의 10%를 할인받을 수 있습니다. 등록은 8월 첫 몇 주 동안 진행되므로, 8월 8일까지 지원서를 제출하시기 바랍니다. 시에라 국제법 아카데미에서는 지역 및 국제 학생 모두에게 다양한 장학금과 연구 보조금이 제공된다는 점을 참고하세요.

시에라 국제법 아카데미가 제공하는 과정과 기회에 대한 자세한 정보는 학교 웹사이트를 방문하세요: www.sierraintlaw.edu.`,
  koreanNouns: `Sierra International Law Academy

If you are <mark>찾고 있는</mark> a degree in international law, look no further than Sierra International Law Academy.

A new academic year begins this September, and the school offers a wide range of courses in various branches of international law, such as international <mark>형법</mark>, <mark>세계 무역법</mark>, international environmental law, and more. The classes are taught by <mark>저명한</mark> lawyers and lecturers with <mark>풍부한</mark> experience in the field of international law. Upon completing a four-year educational program, students are granted not only an international law degree, but also an internship at one of the international law firms that Sierra International Law Academy has an internship <mark>제휴</mark> agreement with. This internship program has made the institution one of the top law schools in the country.

The tuition at Sierra International Law Academy is $8,000 for local residents and $28,000 for out-of-state students. However, you can become <mark>자격이 있는</mark> 10% off your annual tuition if you use the promo code "FREE LAW" when applying to Sierra International Law Academy. Enrollment takes place <mark>내내, 전체에 걸쳐</mark> the first few weeks of August, so be sure to submit your application no later than August 8. Please note that a number of scholarships as well as research grants are available at Sierra International Law Academy to local and international students alike.

For more information about the courses and opportunities offered by Sierra International Law Academy, visit the school's website: www.sierraintlaw.edu.`,

  wordPairs: {
    "in search of": "찾고 있는",
    "criminal law": "형법",
    "world trade law": "세계 무역법",
    renowned: "저명한",
    vast: "풍부한",
    affiliation: "제휴",
    "entitled to": "자격이 있는",
    throughout: "내내, 전체에 걸쳐",
  },

  questions: [],
};
const advertisement23 = {
  id: 23,
  passage: `Travel the Pacific on Our Amazing Ocean Aurora Cruise Ship

<mark>Welcome aboard</mark>! On Ocean Aurora, our lovely cruise ship, you can <mark>set off</mark> on your <mark>voyage</mark> around the Pacific Ocean, with our expert tour guide showing you around pristine islands and <mark>majestic</mark> mountains. The journey takes about two weeks, and you're <mark>bound</mark> to have a lot of fun. The itinerary includes three major locations. Following your departure from Los Angeles, you will set off for the <mark>idyllic</mark> Society Islands, journeying through Cabo San Lucas and the Marquesas Islands along the way. Throughout the cruise, there will be lots of activities, ranging from meet-and-greet sessions and <mark>onboard parties</mark> to snorkeling and paddleboarding. You will find plenty of opportunities to enjoy socializing with other passengers and our crew members.

Our cruise ship leaves the Port of Los Angeles at 9 a.m. on the first Monday of every month. Prices are per person based on <mark>double occupancy</mark> and range from $8,000 for a porthole stateroom to $16,000 for a VIP grand suite. Students with a valid student ID are entitled to a 20% discount, and we offer a whopping 50% off the standard fare for children under the age of 14.

Book your cruise online at www.oceanauroracruises.com or by calling our toll-free number: (888) 168-8989. If you're interested in booking a VIP grand suite, please let us know by sending an email to vip@oceanauroracruises.com.`,

  translation: `태평양을 여행하는 놀라운 오션 오로라 크루즈 선박

환영합니다! 저희의 아름다운 크루즈 선박인 오션 오로라에서, 전문 가이드와 함께 태평양 주변의 순수한 섬들과 웅장한 산들을 둘러보는 여행을 시작할 수 있습니다. 여행은 약 2주 정도 소요되며, 많은 즐거움을 경험하실 수 있습니다. 일정에는 세 개의 주요 장소가 포함됩니다. 로스앤젤레스에서 출발한 후, 카보 산 루카스와 마르케사스 제도를 거쳐 아름다운 소사이어티 제도로 향하게 됩니다. 크루즈 여행 내내 만남의 시간, 선상 파티, 스노클링, 패들보딩 등 다양한 활동이 준비되어 있습니다. 다른 승객들과 승무원들과 교류할 수 있는 많은 기회를 찾으실 수 있습니다.

저희 크루즈 선박은 매월 첫 번째 월요일 오전 9시에 로스앤젤레스 항구에서 출발합니다. 가격은 2인 기준으로 책정되며, 현창 객실은 $8,000부터 VIP 그랜드 스위트는 $16,000까지 다양합니다. 유효한 학생증을 소지한 학생들은 20% 할인을 받을 수 있으며, 14세 미만의 어린이들에게는 표준 요금에서 50%의 큰 할인을 제공합니다.

크루즈 예약은 www.oceanauroracruises.com에서 온라인으로 하거나 무료 전화번호 (888) 168-8989로 전화하여 할 수 있습니다. VIP 그랜드 스위트 예약에 관심이 있으시면, vip@oceanauroracruises.com으로 이메일을 보내 알려주시기 바랍니다.`,
  koreanNouns: `Travel the Pacific on Our Amazing Ocean Aurora Cruise Ship

<mark>환영합니다</mark>! On Ocean Aurora, our lovely cruise ship, you can <mark>시작하다</mark> on your <mark>항해</mark> around the Pacific Ocean, with our expert tour guide showing you around pristine islands and <mark>웅장한</mark> mountains. The journey takes about two weeks, and you're <mark>~하기로 되어 있다</mark> to have a lot of fun. The itinerary includes three major locations. Following your departure from Los Angeles, you will set off for the <mark>아름다운</mark> Society Islands, journeying through Cabo San Lucas and the Marquesas Islands along the way. Throughout the cruise, there will be lots of activities, ranging from meet-and-greet sessions and <mark>선상 파티</mark> to snorkeling and paddleboarding. You will find plenty of opportunities to enjoy socializing with other passengers and our crew members.

Our cruise ship leaves the Port of Los Angeles at 9 a.m. on the first Monday of every month. Prices are per person based on <mark>2인 기준 객실 사용</mark> and range from $8,000 for a porthole stateroom to $16,000 for a VIP grand suite. Students with a valid student ID are entitled to a 20% discount, and we offer a whopping 50% off the standard fare for children under the age of 14.

Book your cruise online at www.oceanauroracruises.com or by calling our toll-free number: (888) 168-8989. If you're interested in booking a VIP grand suite, please let us know by sending an email to vip@oceanauroracruises.com.`,
  wordPairs: {
    "Welcome aboard": "환영합니다",
    "set off": "시작하다",
    voyage: "항해",
    majestic: "웅장한",
    bound: "~하기로 되어 있다",
    idyllic: "아름다운",
    "onboard parties": "선상 파티",
    "double occupancy": "2인 기준 객실 사용",
  },

  questions: [],
};

const advertisement24 = {
  id: 24,
  passage: `NorthStar Freight Solutions

We have several vacancies for part-time employees who are available to work morning shifts starting daily from 7 a.m. and finishing at 11 a.m.

The vacancies include:

General Manager
The successful candidate will be trained in the skills of conflict management and, preferably, have a background in logistics. In addition, a higher education degree in business administration is a must, and excellent communication skills are certainly a plus.

Truck Mechanic
An ideal candidate for this position must have a high school <mark>diploma</mark> or GED and have at least 3 years of experience in repairing trucks. Preference will be given to those candidates who have received vocational training in the repair and maintenance of commercial trucks.

IT Professional
Our new IT professional must <mark>be competent to</mark> set up a reliable IT infrastructure to support our firm's <mark>logistical operations</mark>. <mark>As an absolute minimum</mark>, the successful candidate will have a higher education degree in IT and at least 1 year of experience in the field.

Administrative Assistant
We need someone who is capable of working around the clock, performing a wide range of administrative duties, maintaining our filing system, and acting as a point of contact for our logistics specialists and truck drivers. A hard-working natural problem-solver with proficiency in basic office software is just what we need.

If you are interested in applying for any of these positions, please send your application and relevant attachments to hr@northstarfreightsolutions.com.`,

  translation: `노스스타 화물 솔루션

매일 오전 7시부터 시작하여 오전 11시에 끝나는 아침 근무가 가능한 시간제 직원을 위한 여러 공석이 있습니다.

공석은 다음과 같습니다:

총괄 매니저
성공적인 후보자는 갈등 관리 기술을 교육받게 되며, 가급적이면 물류 분야의 배경을 가진 사람이어야 합니다. 또한, 경영학 분야의 고등 교육 학위는 필수이며, 뛰어난 의사소통 능력은 확실히 장점입니다.

트럭 정비사
이 직책에 이상적인 후보자는 고등학교 졸업장이나 GED를 보유하고 트럭 수리 경험이 최소 3년 이상 있어야 합니다. 상업용 트럭의 수리 및 유지보수에 대한 직업 훈련을 받은 후보자에게 우선권이 주어집니다.

IT 전문가
우리의 새로운 IT 전문가는 회사의 물류 운영을 지원하기 위한 신뢰할 수 있는 IT 인프라를 구축할 수 있는 능력이 있어야 합니다. 최소한의 요건으로, 성공적인 후보자는 IT 분야의 고등 교육 학위와 해당 분야에서 최소 1년 이상의 경험을 가지고 있어야 합니다.

행정 보조
우리는 24시간 내내 일할 수 있고, 다양한 행정 업무를 수행하며, 파일 시스템을 유지하고, 물류 전문가와 트럭 운전사들의 연락 창구 역할을 할 수 있는 사람이 필요합니다. 기본 사무용 소프트웨어에 능숙한 열심히 일하는 타고난 문제 해결사가 바로 우리가 필요로 하는 사람입니다.

이러한 직책 중 어느 것에든 지원하는 데 관심이 있으시면, 지원서와 관련 첨부 파일을 hr@northstarfreightsolutions.com으로 보내주시기 바랍니다.`,
  koreanNouns: `NorthStar Freight Solutions

We have several vacancies for part-time employees who are available to work morning shifts starting daily from 7 a.m. and finishing at 11 a.m.

The vacancies include:

General Manager
The successful candidate will be trained in the skills of conflict management and, preferably, have a background in logistics. In addition, a higher education degree in business administration is a must, and excellent communication skills are certainly a plus.

Truck Mechanic
An ideal candidate for this position must have a high school <mark>졸업장</mark> or GED and have at least 3 years of experience in repairing trucks. Preference will be given to those candidates who have received vocational training in the repair and maintenance of commercial trucks.

IT Professional
Our new IT professional must <mark>능력이 있어야 합니다</mark> set up a reliable IT infrastructure to support our firm's <mark>물류 운영</mark>. <mark>최소한의 요건으로</mark>, the successful candidate will have a higher education degree in IT and at least 1 year of experience in the field.

Administrative Assistant
We need someone who is capable of working around the clock, performing a wide range of administrative duties, maintaining our filing system, and acting as a point of contact for our logistics specialists and truck drivers. A hard-working natural problem-solver with proficiency in basic office software is just what we need.

If you are interested in applying for any of these positions, please send your application and relevant attachments to hr@northstarfreightsolutions.com.`,
  wordPairs: {
    diploma: "졸업장",
    "be competent to": "능력이 있어야 합니다",
    "logistical operations": "물류 운영",
    "As an absolute minimum": "최소한의 요건으로",
  },

  questions: [],
};

export const advertisementQuestions = [
  advertisement1,
  advertisement2,
  advertisement3,
  advertisement4,
  advertisement5,
  advertisement6,
  advertisement7,
  advertisement8,
  advertisement9,
  advertisement10,
  advertisement11,
  advertisement12,
  advertisement13,
  advertisement14,
  advertisement15,
  advertisement16,
  advertisement17,
  advertisement18,
  advertisement19,
  advertisement20,
  advertisement21,
  advertisement22,
  advertisement23,
  advertisement24,
];
